import { AuthenticationService } from '../../../auth/services/authentication.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  form: FormGroup;
  formBuilder: FormBuilder = new FormBuilder();
  code: string;
  codeExpired: boolean = true;
  isPasswordReset: boolean;
  isLoading: boolean = true;
  get password() {
    return this.form.get('passwordGroup')?.get('password')?.value;
  }
  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setupForm();
    this.verifyResetPassowrd();
  }

  verifyResetPassowrd() {
    this.route.queryParams.subscribe((params) => {
      this.code = params['oobCode'];
      if (this.code) {
        this.authService
          .verifyPasswordResetCode(this.code)
          .then((email) => {
            if (email) this.codeExpired = false;
          })
          .catch((error) => {
            this.codeExpired = true;
          });
      }
      this.isLoading = false;
    });
  }
  setupForm() {
    this.form = this.formBuilder.group({
      passwordGroup: this.formBuilder.group(
        {
          password: ['', [Validators.required, Validators.minLength(8)]],
          confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
        },
        { validator: this.checkPasswords }
      ),
    });
  }

  checkPasswords(group: FormGroup) {
    let password = group.get('password')?.value;
    let confirmPassword = group.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { notSame: true };
  }

  confirmPasswordReset() {
    this.authService
      .confirmPasswordReset(this.code, this.password)
      .then((result) => {
        this.router.navigate([], {});
        this.navigateUser();
        this.isPasswordReset = result;
      });
  }

  navigateUser = () => {
    setTimeout(() => {
      this.router.navigate(['/signin']);
    }, 5000);
  };
}
